import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

// The mutation re-selects quote.status AND project.quoteActivities so the Relay store learns the
// new status and the appended log entry immediately — the lock banner and the activity list render
// without a refetch.
//
// Its activity node selection must stay in step with QuoteActivitySection's fragment, which reads the
// same quoteActivities connection: a field the fragment reads and this omits is absent from the store
// for the row this appends, so the fragment reads undefined for it until the next full fetch.
const mutation = graphql`
	mutation recordQuoteDecisionMutation($input: RecordQuoteDecisionInput!) {
		recordQuoteDecision(input: $input) {
			quote {
				id
				status
			}
			project {
				id
				quoteActivities(first: 100) {
					edges {
						node {
							id
							eventType
							revisionNumber
							createdAt
							clientContactName
							reason
							person {
								id
								fullName
							}
						}
					}
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError, uploadables) {
	const variables = {
		input: {
			csrfToken: Util.getCsrfValue(),
			socketClientId: Util.getClientId(),
			...input,
		},
	};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		uploadables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
